<template>
  <v-container fluid fill-height class="pa-0">
        <v-layout align-center justify-center column fill-height>
          <v-flex>
            <div>
              <p-notepad-launcher ref="notepad"></p-notepad-launcher>
            </div>
          </v-flex>
          <v-flex>
            <h3>Armazenamento disponível offline</h3>
          </v-flex>
          <v-flex>
            <span>total: <strong>{{this.total}} MB</strong> total</span>
          </v-flex>
          <v-flex>
            <span>usado: <strong>{{this.used}} MB</strong> em uso</span>
          </v-flex>
          <v-flex>
            <span>livre: <strong>{{this.available}} MB</strong> disponivel</span>
          </v-flex>
          <v-flex>
            <v-btn @click="reloadPage()"><v-icon right>replay</v-icon>Recarregar página</v-btn>
          </v-flex>
        </v-layout>
    </v-container>
</template>
<style scoped>
</style>
<script>
  import PNotepadLauncher from './shared/PNotepadLauncher'

  export default {
    name: 'HomeOff',
    components: {PNotepadLauncher},
    data: function () {
      return {
        total: 0,
        used: 0,
        available: 0
      }
    },
    mounted () {
      this.$refs.notepad.openNotepad()
      if ('storage' in navigator && 'estimate' in navigator.storage) {
        navigator.storage.estimate().then(estimate => {
          console.log('estimate', estimate)
          this.used = Math.round(estimate.usage / (1000000))
          this.total = Math.round(estimate.quota / (1000000))
          this.available = Math.round(this.total - this.used)
        })
      }
    },
    methods: {
      reloadPage () {
        location.reload(true)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/HomeOff.vue